/**
 * Carousel Expose
 * https://swiperjs.com/
 */

// import Swiper from 'swiper';

import Swiper from "Vendor/swiper.js";
import $ from "jquery";

let carouselExpose = undefined;

let carouselExposeMod = document.querySelector("[data-js='carouselExposeMod']");

export default function carousel() {

	// When Carousel exists
	if (carousel) {

		if (carouselExposeMod) {
			$("#m-account-meine-unterkuenfte").on("show.bs.modal", function () {
				$(".img-resize").resizeToParent();

				let $objMod = $(".carousel-expose-mod");

				setTimeout(function () {

					$objMod.each(function (index, element) {
						let $this = $(this);

						if (!$this.hasClass("swiper-container-horizontal")) {
							carouselExposeMod = new Swiper(this, {
								slidesPerView: 1,
								spaceBetween: 8,
								pagination: {
									el: ".swiper-pagination",
									dynamicBullets: false,
									type: "fraction"
								},
								lazy: {
									loadPrevNext: true,
									loadPrevNextAmount: 1,
								},
								navigation: {
									nextEl: $this.find(".swiper-button-next"),
									prevEl: $this.find(".swiper-button-prev"),
								},
							});
						}

					});
				}, 500);
			});

		} else {

			let $obj = $(".carousel-expose");

			$obj.each(function (index, element) {
				let $this = $(this);

				if (!$this.hasClass("swiper-container-horizontal")) {
					carouselExpose = new Swiper(this, {
						slidesPerView: 1,
						spaceBetween: 8,
						pagination: {
							el: ".swiper-pagination",
							dynamicBullets: false,
							type: "fraction"
						},
						lazy: {
							loadPrevNext: true,
							loadPrevNextAmount: 1,
						},
						navigation: {
							nextEl: $this.find(".swiper-button-next"),
							prevEl: $this.find(".swiper-button-prev"),
						},
					});
				}

			});
		}

	}
}
